module.exports = __webpack_public_path__ + "media/lamp_outside.d920bf8d.mp4";